import React from "react";

export default function EvidenceBadge({ source, externalId, url, label }) {
    const src = (source || "").toUpperCase();
    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="citation-badge"
            data-testid={`evidence-${src}-${externalId}`}
            title={label || `${src}:${externalId}`}
        >
            <span className="font-medium">{src}</span>
            <span className="opacity-70">·</span>
            <span>{externalId}</span>
        </a>
    );
}
